import React from 'react';
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle
} from 'reactstrap';
import { FilterQueueOptions } from './Queue';
import { FilterTagsOptions } from './Tags';
import { useSelector } from 'react-redux';
import { useQueueContentChatContext } from '../../../../../../hooks/useQueueContentChat';
import { FilterStatusOptions } from './Status';

const BallonCheck = () => {
  const systemConfiguration = useSelector((state) => state.systemConfiguration);

  return (
    <div
      style={{
        width: '6px',
        height: '6px',
        borderRadius: '50%',
        backgroundColor: systemConfiguration.primary_color
      }}
    ></div>
  );
};
export const FiltersChat = (props) => {
  const [dropdownQueue, setDropdownQueue] = React.useState(false);
  const [dropdownTags, setDropdownTags] = React.useState(false);
  const [dropdownStatus, setDropdownStatus] = React.useState(false);

  const { filters } = useQueueContentChatContext();

  return (
    <Dropdown
      isOpen={props.openDropDown}
      toggle={props.toggle}
      direction="end"
      nav
    >
      {props.children}
      <DropdownMenu>
        <DropdownItem header>Inicio de chat</DropdownItem>
        <DropdownItem
          onClick={(e) => {
            props.handlerFilter('ACTIVE', 'START_TYPE');
            e.stopPropagation();
          }}
        >
          <div style={{ display: 'flex', padding: 0, marginTop: '3px' }}>
            Contato ativo
            {filters['START_TYPE'] === 'ACTIVE' && <BallonCheck />}
          </div>
        </DropdownItem>
        <DropdownItem
          onClick={(e) => {
            props.handlerFilter('RECEPTIVE', 'START_TYPE');
            e.stopPropagation();
          }}
        >
          <div style={{ display: 'flex', padding: 0, marginTop: '3px' }}>
            Contato receptivo
            {filters['START_TYPE'] === 'RECEPTIVE' && <BallonCheck />}
          </div>
        </DropdownItem>
        <DropdownItem divider />
        <DropdownItem header>Conversa</DropdownItem>
        <DropdownItem style={{ padding: 0 }}>
          <FilterQueueOptions
            open={dropdownQueue}
            openDropDown={setDropdownQueue}
            handlerFilter={props.handlerFilter}
          >
            <DropdownToggle
              onMouseEnter={() => {
                setDropdownQueue(true);
              }}
              onMouseLeave={() => {
                if (!dropdownQueue) {
                  setDropdownQueue(false);
                }
              }}
              onClick={(e) => {
                e.preventDefault();
                setDropdownQueue(!dropdownQueue);
                e.stopPropagation();
              }}
              style={{
                display: 'flex',
                alignContent: 'center',
                border: 'none',
                margin: 0,
                padding: '.9rem',
                width: '100%',
                height: '100%',
                boxShadow: 'none',
                backgroundColor: 'transparent',
                fontWeight: 'initial'
              }}
            >
              <>
                Fila
                {filters['FILA']?.length > 0 && <BallonCheck />}
              </>
            </DropdownToggle>
          </FilterQueueOptions>
        </DropdownItem>
        <DropdownItem style={{ padding: 0 }}>
          <FilterStatusOptions
            open={dropdownStatus}
            openDropDown={setDropdownStatus}
            handlerFilter={props.handlerFilter}
          >
            <DropdownToggle
              onMouseEnter={() => {
                setDropdownStatus(true);
              }}
              onMouseLeave={() => {
                if (!dropdownStatus) {
                  setDropdownStatus(false);
                }
              }}
              onClick={(e) => {
                e.preventDefault();
                setDropdownStatus(!dropdownStatus);
                e.stopPropagation();
              }}
              style={{
                display: 'flex',
                alignContent: 'center',
                border: 'none',
                margin: 0,
                padding: '.9rem',
                width: '100%',
                height: '100%',
                boxShadow: 'none',
                backgroundColor: 'transparent',
                fontWeight: 'initial'
              }}
            >
              Status
              {filters['STATUS']?.length > 0 && <BallonCheck />}
            </DropdownToggle>
          </FilterStatusOptions>
        </DropdownItem>

        <DropdownItem divider />
        <DropdownItem header>Cliente</DropdownItem>
        <DropdownItem style={{ padding: 0 }}>
          <FilterTagsOptions
            open={dropdownTags}
            handlerFilter={props.handlerFilter}
            openDropDown={setDropdownTags}
            tags={props.tags}
          >
            <DropdownToggle
              onMouseEnter={() => {
                setDropdownTags(true);
              }}
              onMouseLeave={() => {
                if (!dropdownTags) {
                  setDropdownTags(false);
                }
              }}
              onClick={(e) => {
                e.preventDefault();
                setDropdownTags(!dropdownTags);
                e.stopPropagation();
              }}
              style={{
                display: 'flex',
                alignContent: 'center',
                border: 'none',
                margin: 0,
                padding: '.9rem',
                width: '100%',
                height: '100%',
                boxShadow: 'none',
                backgroundColor: 'transparent',
                fontWeight: 'initial'
              }}
            >
              Tags
              {filters['TAG']?.length > 0 && <BallonCheck />}
            </DropdownToggle>
          </FilterTagsOptions>
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};
